import LogoMark from "./LogoMark";
import { useLang } from "@/lib/i18n";

const scrollTo = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

const FOOTER_TESTIDS = {
  "#hjem": "footer-link-home",
  "#slik-fungerer-det": "footer-link-how",
  "#partnere": "footer-link-partners",
  "#faq": "footer-link-faq",
  "#kontakt": "footer-link-contact",
};

export default function Footer() {
  const { t } = useLang();

  return (
    <footer
      className="border-t border-[#2D2520] bg-[#0D0B09] overflow-hidden"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-8">
        <div className="flex flex-wrap items-start justify-between gap-10 mb-20">
          <div className="flex items-center gap-3">
            <LogoMark size={40} />
            <div>
              <p className="font-serif text-xl text-[#F9F6F0]">Bordverket</p>
              <p className="text-xs text-[#A69C95]">{t.footer.tagline}</p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-8 text-sm text-[#A69C95]">
            {t.nav.links.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollTo(l.href)}
                data-testid={FOOTER_TESTIDS[l.href]}
                className="hover:text-[#F9F6F0] transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>

        <p
          className="font-serif text-[13vw] leading-none text-center text-[#F9F6F0]/[0.06] select-none whitespace-nowrap"
          aria-hidden="true"
        >
          Bordverket
        </p>

        <div className="mt-10 pt-8 border-t border-[#2D2520] flex flex-wrap items-center justify-between gap-4 text-xs text-[#A69C95]">
          <p>{t.footer.copyright}</p>
          <div className="flex flex-wrap items-center gap-6">
            <a
              href="tel:+4798340354"
              className="hover:text-[#D48C46] transition-colors duration-300"
              data-testid="footer-phone-daniel"
            >
              983 40 354
            </a>
            <a
              href="tel:+4797694791"
              className="hover:text-[#D48C46] transition-colors duration-300"
              data-testid="footer-phone-adrian"
            >
              976 94 791
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
